var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product wrapper"},[_c('div',{staticClass:"product__items",attrs:{"data-aos":"fade","data-aos-duration":"1000","data-aos-once":"true"}},_vm._l((_vm.items),function(item,index){return _c('Card',{key:index,attrs:{"lang":_vm.lang,"type":item.type,"title":item.title,"text":item.text}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }